export default "__VITE_ASSET__DLvjdnBn__"